// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
// eslint-disable-next-line check-file/filename-blocklist
import('@microApp/ApplicationBootstrap');